module.exports = __webpack_public_path__ + "static/media/md-log-out.2deb7d54.svg";